import React from 'react';
import './SongList.css';

const FREE_SONG_LIMIT = 5;

const SongList = ({ songs, onSelect, onCreate, userPlan }) => {
  const isFreePlan = userPlan === 'free';
  const hasReachedFreeLimit = isFreePlan && songs.length >= FREE_SONG_LIMIT;

  return (
    <div className="home-container">
      <div className="home-header">
        <div className="header-text">
          <h1>My Songbook</h1>
          <div style={{display:'flex', gap:'10px', alignItems:'center'}}>
             <p className="subtitle">{songs.length} songs in your library</p>
             
             {/* STATUS BADGES (Keep these so users know their status) */}
             {userPlan === 'free' && (
               <span className="plan-badge badge-free" data-plan-info="Free Plan: There is a 5 song limit, and chord creation is disabled. Upgrade for unlimited songs.">
                 Free Plan
               </span>
             )}
             {(userPlan === 'premium' || userPlan === 'founder_premium') && (
               <span className="plan-badge badge-premium" data-plan-info="Premium Plan: Unlimited songs included.">
                 Premium
               </span>
             )}
             {userPlan === 'original' && (
               <span className="plan-badge badge-original" data-plan-info="Original Member: Unlimited songs and chord creation included.">
                 Original Member
               </span>
             )}
             {hasReachedFreeLimit && <span className="limit-note">5 song limit reached</span>}
          </div>
        </div>
        
        {/* Only the Create Button remains */}
        <button
          className="btn-create-large"
          onClick={onCreate}
          disabled={hasReachedFreeLimit}
          title={hasReachedFreeLimit ? 'Free accounts can create up to 5 songs.' : 'Write a new song'}
        >
          {hasReachedFreeLimit ? 'Song Limit Reached' : '+ Write New Song'}
        </button>
      </div>

      {isFreePlan && (
        <div className={`free-plan-banner ${hasReachedFreeLimit ? 'limit-reached' : ''}`}>
          {hasReachedFreeLimit
            ? 'Free song limit reached. Upgrade for unlimited songs.'
            : 'Free Plan: 5 song limit. Upgrade for unlimited songs.'}
        </div>
      )}

      <div className="song-grid">
        {songs.length > 0 ? (
          songs.map(song => (
            <div key={song._id} className="song-card" onClick={() => onSelect(song)}>
              <div className="card-top-accent"></div>
              <div className="card-content">
                <h3 className="card-title">{song.title || "Untitled Song"}</h3>
                <p className="card-artist">{song.artist || "Unknown Artist"}</p>
                <div className="card-footer">
                  <span className="key-badge">{song.key || "?"}</span>
                  <span className="bpm-badge">{song.bpm ? `${song.bpm} BPM` : ""}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <h3>It's quiet in here...</h3>
            <p>Start writing your first masterpiece!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SongList;
